const matchConfiguration = {
    name: '',
    href: '',
    type: 'private',
    players: 0,
    onlyFriends: true,
    teams: false,
    rounds: 4,
    paintTime: 90,
    wordChooseTime: 20,
    language: 'ES',
    verbs: false,
    adjetives: true,
    dictionary: '',
    hotWord: false,
    drunk: false,
    blind: false,
};

export default matchConfiguration;
